export const equipmentLabelStyle: React.CSSProperties = {
  background: 'rgba(255,255,255,0.85)',
  backdropFilter: 'blur(8px)',
  WebkitBackdropFilter: 'blur(8px)',
  border: '1px solid rgba(10,25,41,0.1)',
  borderLeft: '3px solid rgba(10,25,41,0.25)',
  borderRadius: '6px',
  padding: '3px 8px',
  fontSize: '11px',
  fontFamily: "'Inter', sans-serif",
  color: '#0A1929',
  whiteSpace: 'nowrap' as const,
  fontWeight: 500,
  letterSpacing: '0.01em',
};

export const chemicalLabelStyle: React.CSSProperties = {
  background: 'rgba(255,255,255,0.85)',
  backdropFilter: 'blur(8px)',
  WebkitBackdropFilter: 'blur(8px)',
  border: '1px solid rgba(46,92,138,0.15)',
  borderLeft: '3px solid #2E5C8A',
  borderRadius: '6px',
  padding: '3px 8px',
  fontSize: '11px',
  fontFamily: "'JetBrains Mono', monospace",
  color: '#2E5C8A',
  whiteSpace: 'nowrap' as const,
  fontWeight: 600,
};